import React from 'react'
import { useAssistantChatEmbed } from './assistantChat/useAssistantChatEmbed'

/** 僅提供 embed.js 掛載容器；icon / iframe 開關由 AssistantChat 產生 */
export default function FrontPageChatWidget() {
  const { containerId } = useAssistantChatEmbed()

  return <div id={containerId} />
}
